import * as React from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { styled } from "@mui/material/styles";

const size = {
  width: 400,
  height: 150,
};

const StyledText = styled("text")(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: "middle",
  dominantBaseline: "central",
  fontSize: 13,
}));

function PieCenterLabel({ children }) {
  const { width, height, left, top } = useDrawingArea();
  return (
    <StyledText x={left + width / 2} y={top + height / 2}>
      {children}
    </StyledText>
  );
}

export default function PieChartWithCenterLabel({ claimData }) {
  const non_staffData = claimData.filter(
    (data) => data.designation === "non-staff"
  );
  const non_staffDataValue = non_staffData.reduce(
    (acc, data) => acc + data.amount,
    0
  );

  const staff =
    claimData.reduce((acc, val) => acc + val.amount, 0) - non_staffDataValue;
  const data = [
    { value: staff, label: "Staff", color: "#2c3e50" },
    { value: non_staffDataValue, label: "Non-staff", color: "#d4d4d8" },
  ];
  return (
    <PieChart series={[{ data, innerRadius: 50 }]} {...size}>
      <PieCenterLabel>DES</PieCenterLabel>
    </PieChart>
  );
}
